import { HIDE_MODAL, SHOW_MODAL } from "../../constants/actions";

const initialState = {
    isModalVisible: false,
  };
  
  const changePassModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case SHOW_MODAL:
        return { ...state, isModalVisible: true };
      case HIDE_MODAL:
        return { ...state, isModalVisible: false };
      default:
        return state;
    }
  };
  
  export default changePassModalReducer;
  